import { Panel, PanelHeader, PanelBody } from "@/shared";

interface Props {
  error: any;
}
export function PanelError({ error }: Props) {
  return (
    <Panel>
      <PanelHeader noButton={true}>Error</PanelHeader>
      <PanelBody>
        <div>
          <div className="w-full my-[10%] text-center">
            <h1>Error</h1>
            message : {error.message}
          </div>
        </div>
      </PanelBody>
    </Panel>
  );
}
